import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectBidService } from '../Services/projectbid.service';
import { ProjectBid } from '../objects/ProjectBid';
import { BidContact } from '../objects/BidContact';
import { Contractor } from '../objects/Contractor';
import { ProjectType } from '../objects/ProjectType';
import { ProjectTypeService } from '../Services/project-type.service';

@Component({
  selector: 'app-project-bid-edit',
  templateUrl: './project-bid-edit.component.html',
  styleUrls: ['./project-bid-edit.component.css'],
})
export class ProjectBidEditComponent implements OnInit {

  projectTypes: ProjectType[] = [];

  private defaultContractor: Contractor = {
    id: 0, name: '', age: 0, jobTitle: '',
    cellPhone: '', email: '', salary: 0, hourlyWage: 0, imageContent: ''
  };

  projectBid: ProjectBid = {
    id: 0,
    companyName: '',
    contractor: this.defaultContractor,
    bidAmount: 0,
    projectDetails: '',
    projectTypeId: null as any,
    projectType: { id: 0, type: '' },
    status: '',
    contacts: [],
  };

  // ── Contact management ─────────────────────────────────────────
  contacts: BidContact[] = [];
  showContactForm = false;
  newContact: BidContact = { name: '', title: '', email: '', phone: '' };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private projectBidService: ProjectBidService,
    private projectTypeService: ProjectTypeService
  ) {}

  ngOnInit() {
    this.projectTypeService.getProjectTypes().subscribe(types => {
      this.projectTypes = types;
      this.route.paramMap.subscribe(params => {
        const id = parseInt(params.get('id') || '0', 10);
        if (id > 0) { this.loadProjectBid(id); }
      });
    });
  }

  loadProjectBid(id: number) {
    this.projectBidService.getProjectBidById(id).subscribe(bid => {
      this.projectBid = bid;
      this.contacts = bid.contacts ? [...bid.contacts] : [];
      const found = this.projectTypes.find(t => t.id === bid.projectTypeId);
      if (found) { this.projectBid.projectType = found; }
    });
  }

  onProjectTypeChange(id: number) {
    const found = this.projectTypes.find(t => t.id == id);
    if (found) {
      this.projectBid.projectType = { ...found };
      this.projectBid.projectTypeId = found.id;
    }
  }

  addContact(): void {
    if (!this.newContact.name.trim()) { return; }
    this.contacts.push({ ...this.newContact });
    this.newContact = { name: '', title: '', email: '', phone: '' };
    this.showContactForm = false;
  }

  cancelContact(): void {
    this.newContact = { name: '', title: '', email: '', phone: '' };
    this.showContactForm = false;
  }

  removeContact(index: number): void {
    this.contacts.splice(index, 1);
  }

  goBack() {
    this.router.navigate(['/project-bids']);
  }

  saveProjectBid() {
    const payload: ProjectBid = { ...this.projectBid, contacts: [...this.contacts] };
    this.projectBidService.editProjectBid(payload).subscribe(() => {
      this.router.navigate(['/project-bids']);
    });
  }
}
